import { render, staticRenderFns } from "./SummaryRedeem.vue?vue&type=template&id=7a654c8e&"
import script from "./SummaryRedeem.vue?vue&type=script&lang=js&"
export * from "./SummaryRedeem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports